<div class="lista-ficha-content">
  <app-ficha-table-home [propostas]="propostas" [idFase]="idFase" (emitOrdenacao)="emitOrdenacao.emit($event)"></app-ficha-table-home>
  <div *ngIf="propostas.length === 0">
    <h2>Não foram encontradas propostas para essa fase</h2>
  </div>
</div>
